"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _layout = _interopRequireDefault(require("./layout"));
var _configContext = require("../context/config-context");
var _bundleContext = require("../context/bundle-context");
var _loader = _interopRequireDefault(require("./loader"));
var _errorBoundary = _interopRequireDefault(require("./common/error/error-boundary"));
/**
 * Local Imports
 */

/**
 * PreCheckPage Component
 *
 * @param {Object} props React props
 * @param {Object} props.searchParams Parameters for search functionality
 * @param {string} props.plid Unique identifier for the API
 * @param {string} props.paymentConfigUrl URL for the payment configuration
 * @param {string} props.hostname Hostname for the API
 * @returns {React.ReactElement} PreCheckPage Component
 * @public
 */
function PreCheckPage(props) {
  const onClient = typeof window !== 'undefined';
  return onClient ? /*#__PURE__*/_react.default.createElement(_configContext.ConfigProvider, props, /*#__PURE__*/_react.default.createElement(_bundleContext.BundleProvider, null, /*#__PURE__*/_react.default.createElement(_errorBoundary.default, null, /*#__PURE__*/_react.default.createElement(_layout.default, null)))) : /*#__PURE__*/_react.default.createElement(_loader.default, null);
}
var _default = exports.default = PreCheckPage;
PreCheckPage.propTypes = {
  searchParams: _propTypes.default.object,
  plid: _propTypes.default.string,
  hostname: _propTypes.default.string,
  paymentConfigUrl: _propTypes.default.string,
  asModal: _propTypes.default.bool
};